@for (filter of gridFilterGroup.filters; track trackByGridFilter(idx, filter); let idx = $index) {

<h-dynamic-box
    [ngClass]="{
            'filter-item-colors': isFilterTypeColors,
            'filter-item-colors-mobile': isFilterTypeColors && isMobile,
            'filter-item-grid': !isFilterTypeColors,
            'filter-item-grid-mobile': !isFilterTypeColors && isMobile,
        }"
    [boxType]="getBoxtype(filter.facetIsCrawlable)"
    [linkUrl]="
        getBoxtype(filter.facetIsCrawlable) === 'link'
            ? getFacetUrl(filter, gridFilterGroup.facetUrlParameterName)
            : undefined
    "
    [forceStyleCheckbox]="filter.facetIsCrawlable && isFilterTypeColors"
    [value]="filter.name"
    [isHref]="true"
    [labelValue]="getLabelValue(filter)"
    [displayLabelWithImage]="isFilterTypeColors"
    [imageSrc]="isFilterTypeColors ? getAsset(filter) : undefined"
    [inputId]="gridFilterGroup.name + '_' + filter.name"
    [formGroup]="filterGroupForm"
    [formName]="gridFilterGroup.name + '_' + filter.name"
    [checked]="filter.selected"
    [checkedImageVariant]="filter.selected"
    [inputAriaInvalid]="!filter.selected"
    [titleValue]="getAriaLabel(filter)"
    [backgroundColorWhite]="true"
    (handleClick)="onHandleClick($event, filter)">
</h-dynamic-box>

}
